export const doesBrowserSupportPWA: () => boolean = () => 'serviceWorker' in navigator;
